import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { t } from 'i18next';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import CalendarPicker from '../../util/CalendarPicker';

interface Holiday { id: number; date: string; name: string; isRecurring: boolean; }

const HrPublicHolidaySettings: React.FC = () => {
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState({ date: '', name: '', isRecurring: false });

  const load = useCallback(async () => {
    try { const { data } = await axios.get('hr-public-holiday'); setHolidays(Array.isArray(data) ? data : []); } catch {}
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleAdd = async () => {
    if (!form.date || !form.name) return;
    try { await axios.post('hr-public-holiday/add', form); setAdding(false); setForm({ date: '', name: '', isRecurring: false }); load(); } catch {}
  };

  const handleDelete = async (id: number) => {
    try { await axios.delete(`hr-public-holiday/${id}`); load(); } catch {}
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-[10px]">
        <p className="text-[11px]" style={{ color: 'var(--text-color-calendar-week)' }}>
          Public holidays are excluded from leave calculations
        </p>
        <button type="button" onClick={() => setAdding(true)}
          className="btn-primary">
          <AddIcon sx={{ fontSize: 14 }} /> {t('Add')}
        </button>
      </div>
      {adding && (
        <div className="flex gap-[8px] p-[8px] mb-[8px] rounded-[5px] bg-[var(--btn-user-form)] border border-[var(--border-input)]">
          <CalendarPicker mode="single" variant="field" output="string" value={form.date} onChange={(v) => setForm(f => ({ ...f, date: v }))} />
          <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
            placeholder="Holiday name" className="flex-1 text-[13px] bg-[var(--bg-input)] text-[var(--text-color)] rounded-[5px] px-[8px] py-[4px] timesheet-edit-input" />
          <label className="flex items-center gap-[4px] text-[12px] whitespace-nowrap" style={{ color: 'var(--text-color)' }}>
            <input type="checkbox" checked={form.isRecurring} onChange={e => setForm(f => ({ ...f, isRecurring: e.target.checked }))} /> Yearly
          </label>
          <button type="button" title="Save" onClick={handleAdd} style={{ color: '#43c98a' }}><CheckIcon sx={{ fontSize: 18 }} /></button>
          <button type="button" title="Cancel" onClick={() => setAdding(false)} style={{ color: '#f76f8e' }}><CloseIcon sx={{ fontSize: 18 }} /></button>
        </div>
      )}
      <div className="flex flex-col gap-[4px]">
        {holidays.map(h => (
          <div key={h.id} className="flex items-center gap-[8px] p-[8px] rounded-[5px] bg-[var(--btn-user-form)] border border-[var(--border-input)]">
            <span className="text-[12px] font-mono" style={{ color: 'var(--text-color-calendar-week)', minWidth: 90 }}>{h.date}</span>
            <span className="flex-1 text-[13px]" style={{ color: 'var(--text-color)' }}>{h.name}</span>
            {h.isRecurring && <span className="text-[10px] px-[5px] py-[1px] rounded-[3px]" style={{ background: 'var(--bg-input)', color: 'var(--text-color-calendar-week)' }}>yearly</span>}
            <button type="button" title="Delete" onClick={() => handleDelete(h.id)} style={{ color: '#f76f8e', display: 'flex' }}>
              <DeleteIcon sx={{ fontSize: 16 }} />
            </button>
          </div>
        ))}
        {holidays.length === 0 && !adding && (
          <div className="text-center py-[20px] text-[13px]" style={{ color: 'var(--text-color-calendar-week)', opacity: 0.6 }}>{t('Empty')}</div>
        )}
      </div>
    </div>
  );
};

export default HrPublicHolidaySettings;
